import { render, staticRenderFns } from "./NwxPagination.vue?vue&type=template&id=a45c1042&scoped=true"
import script from "./NwxPagination.vue?vue&type=script&lang=js"
export * from "./NwxPagination.vue?vue&type=script&lang=js"
import style0 from "./NwxPagination.vue?vue&type=style&index=0&id=a45c1042&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a45c1042",
  null
  
)

export default component.exports